import { useState } from "react";
import { getWcInfo } from "features/wc/api/wcApi";
import { WcInfoList } from "features/wc/types";

/**
 * トイレ最新情報を取得するフック
 */
export default function useWcInfo() {
  // トイレ最新情報一覧
  const [wcInfoList, setWcInfoList] = useState<WcInfoList>();
  // ローディングフラグ
  const [isLoading, setIsLoading] = useState(false);

  /**
   * トイレ最新情報取得
   * @param building_id 建物ID
   */
  const get = async (building_id: number) => {
    setIsLoading(true);
    try {
      // APIを呼び出し
      const result = await getWcInfo(building_id);
      setWcInfoList(result);
    } catch (e) {
      // 取得失敗時は空を返すようにする
      setWcInfoList([]);
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return [{wcInfoList, isLoading}, {get}] as const;
}
